<template>
  <div>
    <div class="relative z-0 flex -space-x-1 overflow-hidden">
      <div
        v-for="(flag, index) in flags"
        :key="flag.id"
        v-tooltip.bottom="flag.item_title"
        class="relative z-30 inline-block w-6 h-6 border-2 border-white rounded-full cursor-help"
        :style="{
          backgroundColor: flag.item_color || '#ccc',
          zIndex: calculateZIndex(index)
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MiaFlagsPreview',

  props: {
    flags: {
      type: Array,
      required: true
    }
  },

  methods: {
    calculateZIndex(index) {
      return (this.flags.length - index - 1) * 10
    }
  }
}
</script>
